import {EventEmitter, Injectable, Output} from '@angular/core';
import {UserService} from "./user.service";
import { HttpClient,HttpHeaders,HttpErrorResponse } from '@angular/common/http';
import {Observable} from "rxjs/Observable";
import { environment } from '../../environments/environment';

@Injectable()
export class ExchangeService {
  exchange_url: string = "";


    constructor(private userService: UserService,private http: HttpClient) {
    }
    private httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    @Output() NewOrderEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() FreezedOrderEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() CompleteOrderEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() WalletUpdateEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() usercurrencychange: EventEmitter<boolean> = new EventEmitter();
    @Output() socketconnection: EventEmitter<boolean> = new EventEmitter();
    toggleNewOrderNotification(){
        this.NewOrderEvent.emit();
    }
    toggleFreezedOrderNotification(){
        this.FreezedOrderEvent.emit();
    }
    toggleCompleteOrderNotification(){
        this.CompleteOrderEvent.emit();
    }
    toggleWalletUpdate(){
        this.WalletUpdateEvent.emit();
    }
    toggleUserCurrency(){
        this.usercurrencychange.emit();
    }
    toggleSocket() {
        this.socketconnection.emit();
    }
    public getEmailVerified(id): Observable<any> {
        return this.userService.userequest('get', 'accountverify', null, { str: id })
    }
    // Unused endpoint - not called anywhere in the app
    // public getUserCurrency():Observable<any> {
    //     return this.userService.userequest('get','usercurrency');
    // }
    // public getAdminConfiguration(userId): Observable<any> {
    //   return this.http.get(this.exchange_url+'price_configs/'+userId,this.httpOptions);
    // }
    // public getAuctionConfiguration(userId): Observable<any> {
    //   return this.http.get(this.exchange_url+'auction_configs/'+userId,this.httpOptions);
    // }
    // public getOtcConfiguration(userId): Observable<any> {
    //   return this.http.get(this.exchange_url+'otc_configs/1',this.httpOptions);
    // }

    // public getPriceChannel(): Observable<any> {
    //   return this.http.get(this.exchange_url+'getPriceChannel',this.httpOptions);
    // }

}



// WEBPACK FOOTER //
// ./src/app/services/exchange.service.ts